import emitter from 'tiny-emitter/instance'

// Preparation for Nuxt 3 where the Eventbus is not available anymore, see: https://v3-migration.vuejs.org/breaking-changes/events-api.html#event-bus
export const EventBus = {
    $on: (...args) => emitter.on(...args),
    $once: (...args) => emitter.once(...args),
    $off: (...args) => emitter.off(...args),
    $emit: (...args) => emitter.emit(...args),
}
